import { render, staticRenderFns } from "./affiliate-review-page.vue?vue&type=template&id=49e74b2d&scoped=true&"
import script from "./affiliate-review-page.vue?vue&type=script&lang=ts&"
export * from "./affiliate-review-page.vue?vue&type=script&lang=ts&"
import style0 from "./affiliate-review-page.vue?vue&type=style&index=0&id=49e74b2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e74b2d",
  null
  
)

export default component.exports